import { mapLoad } from '../typesActions/types';

export const stateMap = () => {
	return {
		type: mapLoad.MAP_LOADED
	};
};
